const AboutUsMobileBottomVector = ({
  width = 293,
  height = 329,
  fill = "#F8EDE3",
  className = ""
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 293 329"
      fill="none"
      className={className}
    >
      <path
        d="M291.957 314.603L219.41 4.64222C218.809 2.07463 216.24 0.487454 213.681 1.08638L-96.2794 73.6334C-98.8902 74.2445 -100.528 76.9075 -99.8847 79.5016C-56.9652 251.501 115.107 358.302 288.288 320.431C290.898 319.857 292.558 317.207 291.949 314.605L291.957 314.603Z"
        fill={fill}
      />
    </svg>
  );
};

export default AboutUsMobileBottomVector;
